import type { ComponentType } from 'react'
import { type RouteObject } from 'react-router-dom'
import { createPermissionGuardedPage } from '@/shared/components/create-permission-guarded-page'
import { ClientPermissions } from './permissions'
import { PayrollPermissions } from '@/features/payroll/permissions'

async function lazyGuardedRoute(
  importPage: () => Promise<{ default: ComponentType } | Record<string, ComponentType>>,
  exportName: string,
  perm: string | readonly string[] = ClientPermissions.identityAccess,
  mode: 'all' | 'any' = 'any',
): Promise<{ Component: ComponentType }> {
  const mod = await importPage()
  const Page =
    'default' in mod && mod.default
      ? mod.default
      : (mod as Record<string, ComponentType>)[exportName]
  if (!Page) {
    throw new Error(`Client route page export "${exportName}" not found`)
  }
  return {
    Component: createPermissionGuardedPage(perm, Page, { mode, administratorBypass: true }),
  }
}

export const clientRoutes: RouteObject[] = [
  {
    path: 'admin/contracts',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/client-contract-register-page'),
        'ClientContractRegisterPage',
        ClientPermissions.contractsAccess,
      ),
  },
  {
    path: 'accounts/contracts',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/client-contract-register-page'),
        'ClientContractRegisterPage',
        ClientPermissions.contractsAccess,
      ),
  },
  {
    path: 'admin/clients',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/client-identity-list-page'),
        'ClientIdentityListPage',
        ClientPermissions.directoryAccess,
        'any',
      ),
  },
  {
    path: 'admin/clients/:clientId',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/client-identity-card-page'),
        'ClientIdentityCardPage',
        ClientPermissions.directoryAccess,
        'any',
      ),
  },
  {
    path: 'admin/clients/:clientId/economics',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/client-period-economics-page'),
        'ClientPeriodEconomicsPage',
        [
          ...ClientPermissions.identityAccess,
          PayrollPermissions.adminDashboardRead,
          PayrollPermissions.manage,
        ],
      ),
  },
]
